import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
import leftArrow from "../../../assets/images/left-arrow.svg";
import storePreview from "../../../assets/images/store-image.svg";
import productLogo1 from "../../../assets/images/product-1.svg";
import productLogo2 from "../../../assets/images/product-2.svg";
import productLogo3 from "../../../assets/images/product-3.svg";
import productLogo4 from "../../../assets/images/product-4.svg";
import addedProduct from "../../../assets/images/added-product-icon.svg";
import shareStoreMedia1 from "../../../assets/images/media-1.svg";
import shareStoreMedia2 from "../../../assets/images/media-2.svg";
import shareStoreMedia3 from "../../../assets/images/media-3.svg";
import shareStoreMedia4 from "../../../assets/images/media-4.svg";
import shareStoreMedia5 from "../../../assets/images/media-5.svg";
import offlineStore from "../../../assets/images/offline-store.svg";
import commingSoon from "../../../assets/images/comming-soon-image.svg";
import uploadIcon from "../../../assets/images/upload-icon.svg";
import descriptionIcon from "../../../assets/images/description-icon.svg";
import { getConsumerDetails, getStoreDetailsPublic, getStoreProductsListPublic, getStorePublicApi } from "../../../services";
import IsLoadingHOC from "../../HOC/loader/IsLoadingHOC";
import userImage from "../../../assets/images/store-placeholder-josh.svg";
import ConsumerViewShimmer from "./ConsumerViewShimmer";
import CardShimmer from "../../common/CardShimmer";
import { useDispatch } from "react-redux";
import { CONSUMER_DETAILS } from "../../../redux/action_type";
import { onJustReducerUpdate } from "../../../redux/action";
import { onHTMLParse } from "../../../utils/common";


const ConsumerView = (props) => {
  const [storeDetailspublic, setStoreDetailsPublic] = useState([]);
  const [storeDetailsPubliclist, setStoreDetailsPublicList] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [lastList, setLastList] = useState(false);
  const [selectedCategory, setselectedCategory] = useState("")
  const [consumerProducts, setConsumerproducts] = useState("")
  const store_id = props?.match?.params?.id;
  const [detailLoading, setDetailLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!props.match.params.id) {
      return;
    }
    setDetailLoading(true)
    getStoreDetailsPublic(store_id).then((res) => {
      setDetailLoading(false)
      if (res.status) {
        dispatch(onJustReducerUpdate(res.data, CONSUMER_DETAILS))
        setStoreDetailsPublic(res.data);
      }
    });
    getConsumerDetails(store_id).then((res) => {
      if (res.status) {
        setConsumerproducts(res.data)
      }
    })
    return () => dispatch(onJustReducerUpdate({}, CONSUMER_DETAILS))
  }, []);

  useEffect(() => {
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [currPage]);

  useEffect(() => {
    if (!props.match.params.id) {
      return;
    }
    const store_id = props.match.params.id;
    const fetchData = async () => {
      let payload = {
        page: currPage - 1,
        id: store_id,
        category_name: selectedCategory
      };
      if (currPage === 1) {
        setIsLoading(true)
      }
      setProductLoading(true)
      const res = await getStoreProductsListPublic(payload);
      setProductLoading(false)
      setIsLoading(false)
      if (!res.data.length) {
        setLastList(true);
        return;
      }
      setPrevPage(currPage);
      setStoreDetailsPublicList([...storeDetailsPubliclist, ...res.data]);
    };
    if (!lastList && prevPage !== currPage) {
      fetchData();
    }
  }, [currPage, lastList, prevPage]);

  const apiData = async (source,josh_user_id,tracking_id,product_url) =>{
    const trackingURLShoogloo = `${product_url}&p1=${josh_user_id}&p2=${tracking_id}&p3=josh_p&p4=shoogloo`;
    const trackingURLCueLinks = `${product_url}&subid1=${josh_user_id}&subid2=${tracking_id}&subid3=josh_p&subid4=cuelinks`;
    const trackingURL = `${product_url}&uid=${josh_user_id}&uid2=${tracking_id}&uid3=josh_b`;

    let payload = {};
    if (source === "shoogloo") {
      payload.p1=josh_user_id;
      payload.p2=tracking_id;
      payload.p3="josh_p";
      payload.p4="shoogloo";
    } else if (source === "cuelinks") {
        payload.subid1=josh_user_id;
        payload.subid2=tracking_id;
        payload.subid3="josh_p";
        payload.subid4="cuelinks";
    }
   const response = await getStorePublicApi(payload,source)
   if (response?.data?.statusCode === 200) {
     if (source === "shoogloo") {
       window.open(trackingURLShoogloo);
     } else if (source === "cuelinks") {
       window.open(trackingURLCueLinks);
     } else {
       window.open(trackingURL);
     }
   }
 }
 
  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight) {
      setCurrPage(currPage + 1);
    }
  };
  // const handleActiveLink = async (e) => {
  //   setStoreDetailsPublicList([])
  //   setselectedCategory(e)
  //   setCurrPage(1)
  //   setPrevPage(0)
  //   setLastList(false)
  //   let payload = {
  //     page: 0,
  //     id: store_id,
  //     category_name: e
  //   };
  //   let data = [...consumerProducts]
  //   data.forEach(function (item, i) {
  //     if (item.category_name === e) {
  //       data.splice(i, 1);
  //       data.unshift(item);
  //     }
  //   });
  //   setConsumerproducts(data)
  //   const res = await getStoreProductsListPublic(payload);
  //   if (!res.data.length) {
  //     setLastList(true);
  //     return;
  //   }
  //   setPrevPage(currPage);
  //   setStoreDetailsPublicList(res?.data);
  // }

  const handleActiveLink = async (e) => {
  setStoreDetailsPublicList([]);
  setselectedCategory(e);
  setCurrPage(1);
  setPrevPage(0);
  setLastList(false);
  let payload = {
    page: 0,
    id: store_id,
    category_name: e
  };

  const res = await getStoreProductsListPublic(payload);
  if (!res.data.length) {
    setLastList(true);
    return;
  }
  setPrevPage(currPage);
  setStoreDetailsPublicList(res?.data);
}

  return (
    <>
      {/* <Header className="hide-mob-view" /> */}
      <div className="custom-container">
        {detailLoading || isLoading ? <ConsumerViewShimmer /> : <div className={`consumer-view-wrap ${!storeDetailspublic?.status ? "offline-consumer" : ""}`}>
          {/* <div className="common-header-bar">
            <h2>Leslie Alexander’s Shoe</h2>{" "}
          </div> */}
          <div className="edit-store">
            <div className="store-profile consumer-banner-wrap">
              <div className={storeDetailspublic?.image?`store-image-wrap`:`store-image-wrap store-plcaeholder`}>
                <img src={storeDetailspublic?.image || userImage} alt="" />
              </div>
              <p> {storeDetailspublic?.store_name || ""}</p>
              <span>
                {storeDetailspublic?.description || ""}
              </span>
            </div>
            {storeDetailspublic?.status && <div className="select-product-tab">
              <ul>
                {consumerProducts?.length > 0 ? < li >
                  <a className={`${selectedCategory === "" ? "active" : ""}`} href="javascript:void(0)" onClick={(e) => handleActiveLink("")}>All</a>
                </li> : <></>}
                {consumerProducts?.map((val, index) => {
                  return (
                    <li key={index}>
                      <a className={`${selectedCategory === val.category_name ? "active" : ""}`} href="javascript:void(0);" onClick={(e) => handleActiveLink(val.category_name)}>
                        {val.category_name}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>}
            {storeDetailsPubliclist?.length > 0 ? (
              <>
                <div className="store-cards-wrap store-cards-wrap-consumer">
                  <div className="row">
                    {storeDetailsPubliclist?.map((val, index) => {
                      const productURL = `${val?.product_url}&uid=${val?.josh_user_id}&uid2=${val?.tracking_id}&uid3=${val.type === "Product" ? "josh_p" : "josh_b"}`
                      return (
                        <div key={index} className="col-md-3 consumer-card-container">
                          <div className="store-card consumer-store-card" 
                          onClick={()=>apiData(val?.source,val?.josh_user_id,val?.tracking_id,val?.product_url)}
                          // onClick={() => JSON.parse(val?.is_status) && window.open(productURL)}
                          >
                            {!JSON.parse(val?.is_status) && <div className="out-of-stock-bar">
                              <h2> Out of stock</h2>
                            </div>}
                            <div className={val?.source==="cuelinks"?`product-image-store cuelink-images`: `product-image-store`}>
                              <img src={val.image} alt="" />
                            </div>
                            <div className="product-details-wrap">
                              <div className="added-product">
                                <img src={addedProduct} alt="" />
                              </div>
                              <div className="product-name">{val.pro_name}</div>
                              <div className="product-description" dangerouslySetInnerHTML={{ __html: onHTMLParse(val?.pro_desc) }} >
                              </div>
                              {val.was_price === "" && val.price === "" ? "" :
                                <div className="product-price">
                                  {" "}
                                  {val.was_price === val.price ? "" : <span className="strike-price">
                                    {" "}
                                    {val.was_price === "" ? <strike>0</strike> : <strike>{val.was_price}</strike>}
                                  </span>}{" "}
                                  {val.price === "" ? <span className="original-price">₹0</span> : <span className="original-price">₹{val.price}</span>}
                                  {val.was_price === val.price ? <span className="off-price"></span> : !val.price || val.was_price === "" || val.was_price===null ? <span className="off-price">0% OFF</span> : <span className="off-price">{`(${(Math.round((val.price / val.was_price) * 100) - 100) * -1}% OFF)`} </span>}
                                </div>}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : !storeDetailspublic?.status && !isLoading ? (
              <div className="no-store-data offline-store-data">
                <div className="offline-data">
                  <img src={offlineStore} alt="" />
                  <p className="heading-1">Currently store is offline</p>
                  <span className="heading-2">
                    {" "}
                    Store will be back online very soon. Stay tuned!
                  </span>
                </div>
              </div>) : storeDetailsPubliclist.length === 0 && !isLoading ? <div className="no-store-data offline-store-data">
                <div className="offline-data comming-soon-data">
                  <img src={commingSoon} alt="" />
                  <p className="heading-1">Coming Soon!</p>
                  <span className="heading-2">I am busy finding the best products for you. Stay tuned. <br />
                    Your favorite products will be added very soon.</span>
                </div>
              </div> : <></>}
          </div>
        </div>}
      </div>
      {/* Share Store Popup Start Here */}
      <div
        className="modal fade share-store-popup select-picture-popup "
        id="share-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        // data-backdrop="static"
        // data-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-popup " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Share
              </h5>
              {/* <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.375 1.375L13.625 13.625M1.37502 13.625L7.50002 7.5L13.625 1.375"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </button> */}
            </div>
            <div className="modal-body ">
              <div className="share-link-wrap">
                <div className="form-gorup">
                  <input
                    className="form-control"
                    placeholder="Share Url"
                    type="text"
                  />
                  <div className="common-btn">
                    <button>Copy Link</button>
                  </div>
                </div>
                <div className="share-others">
                  <p> or share via</p>
                  <ul>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia1} alt="" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia2} alt="" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia3} alt="" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia4} alt="" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="javascript:void(0);">
                        <img src={shareStoreMedia5} alt="" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
      {/* Share Store Popup End Here */}
      {/* Save Store Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="save-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="logout-card">
                <h2>Save changes</h2>
                <p>Do you want to save the changes you made?</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button>Save</button>
                <button data-dismiss="modal">Discard</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Store Popup End Here */}
      {/* Delete Product Popup Start Here*/}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="delete-product"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="logout-card">
                <h2>Remove Product</h2>
                <p>
                  Are you sure you want to remove the product from your store?
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button>Remove</button>
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Product Popup End Here */}
      {/* Choose Picture Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap select-picture-popup"
        id="choose-store-pic"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        // data-backdrop="static"
        // data-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-popup " role="document">
          <div className="modal-content">
            <div className="modal-body ">
              <div className="upload-store-image-wrap">
                <ul>
                  <li>
                    {" "}
                    <input type="file" name="" id="library-pic" />
                    <label htmlFor="library-pic">Choose from library</label>
                  </li>
                  <li>
                    <input type="file" name="" id="photo-pic" />
                    <label htmlFor="photo-pic">Take photo</label>
                  </li>
                  <li>
                    <input type="file" name="" id="current-pic" />
                    <label htmlFor="current-pic">Remove current photo</label>
                  </li>
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Choose Picture Popup End Here */}
      {/* Edit Description Popup Start Here */}
      <div
        className="modal fade logout-popup-wrap select-picture-popup"
        id="edit-description"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        // data-backdrop="static"
        // data-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-popup " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Details
              </h5>
              <button className="done-btn" data-dismiss="modal">
                Done
              </button>
            </div>
            <div className="modal-body ">
              <div className="edit-details-wrap">
                <div className="form-group">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Header"
                  />
                </div>
                <div className="form-group">
                  <img src={descriptionIcon} alt="" />
                  <div className="counter-char">0/150</div>
                  <textarea
                    className="form-control"
                    placeholder="Description"
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                  ></textarea>
                </div>
              </div>
            </div>
            {/* <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal">Cancel</button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {productLoading && <CardShimmer />}
      {/* Edit Description Popup End Here */}
    </>
  );
}

export default IsLoadingHOC(ConsumerView);
